import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class StoriesSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      autoWidth: true,
      pagination: false,
      arrows: true,
      // type   : 'loop',
      gap: `${36 / 375 * 100}vw`,
      padding: `${64.5 / 375 * 100}vw`,
      speed: 900,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          gap: `${74 / 1440 * 100}vw`,
          padding: `${163 / 1440 * 100}vw`,
          // drag: false
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.dom.progress = this.slider.root.querySelector('.splide-carousel-progress-bar');
    // this.slider.on('mounted move', () => {
    //   const end  = this.slider.Components.Controller.getEnd() + 1;
    //   const rate = Math.min( ( this.slider.index + 1 ) / end, 1 );
    //   this.dom.progress.style.width = String( 100 * rate ) + '%';
    // } );
    this.slider.mount();
  }
}

export default StoriesSlides